import { describeFields, FieldWidget } from '../common/fields';
import { LessonTemplateSchema } from './schemas';

export const LESSON_TEMPLATE_FIELDS = describeFields(LessonTemplateSchema, {
  course: { widget: FieldWidget.Select },
  lessonId: {},
  lessonGroup: {},
  label: {},
  lessonType: {},
  isTimesheeted: {},
  homeworkRequired: {},
  quiz: { widget: FieldWidget.Autocomplete, displayField: 'questionSetTitle' },
  active: {},
});
